

























































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
  Ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

const DeliveryFormTypeSelect = defineComponent({
  components: {
    PrettyCheck,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { route, router } = useRouter();
    const filter = reactive({
      typeId: 0,
      checkBox1: false,
      checkBox2: false,
      checkBox3: false,
    });

    function handleSelectionClick() {
      if (filter.checkBox1) {
        router.push({ name: 'DeliveryCreate' });
      } else if (filter.checkBox2) {
        router.push({ name: 'DeliveryCreateByWeight' });
      } else {
        router.push({ name: 'DeliveryCreateFlatRate' });
      }
    }
    watch(() => filter.checkBox1, (newVal, oldVal) => {
      if (filter.checkBox1) {
        filter.checkBox2 = false;
        filter.checkBox3 = false;
      }
    });
    watch(() => filter.checkBox2, (newVal, oldVal) => {
      if (filter.checkBox2) {
        filter.checkBox1 = false;
        filter.checkBox3 = false;
      }
    });
    watch(() => filter.checkBox3, (newVal, oldVal) => {
      if (filter.checkBox3) {
        filter.checkBox1 = false;
        filter.checkBox2 = false;
      }
    });
    return {
      filter,
      handleSelectionClick,
    };
  },
});

export default DeliveryFormTypeSelect;
